import { render, staticRenderFns } from "./DetailsTogglerButton.vue?vue&type=template&id=3b254107&scoped=true"
import script from "./DetailsTogglerButton.vue?vue&type=script&lang=js"
export * from "./DetailsTogglerButton.vue?vue&type=script&lang=js"
import style0 from "./DetailsTogglerButton.vue?vue&type=style&index=0&id=3b254107&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b254107",
  null
  
)

export default component.exports